<section class="container-fluid">
  <div class="row py-2"></div>
  <div class="row d-flex align-items-end">
    <div class="col-md-4 col-lg-3 col-12 mb-2">
      <div class="form-floating">
        <select class="form-select" (change)="getPayrollMonthDetails($event)">
          <option value="" selected disabled>Select Month</option>
          <option *ngFor="let month of listOfPayrollMonths" [value]="month">{{month}}</option>
        </select>
        <label>Payroll Month</label>
      </div>
    </div>
  
    <div class="col-md-4 col-lg-3 col-12 mb-2">
      <div class="form-floating">
        <input type="date" class="form-control" [(ngModel)]="selectedPayDate">
        <label>Select Payment Date<span class="text-danger">*</span></label>
      </div>
    </div>
  
    <div class="col-md-4 col-lg-3 col-12 mb-2"></div>
    <!-- Buttons in the same row -->
    <div class="col-md-4 col-lg-3 col-12 mb-2 d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-success" (click)="downloadExcel()">Download Excel</button>
      <button type="button" class="btn btn-danger" (click)="downloadPDF()">Download Pdf</button>
    </div>
  </div>
  
  

    <div class="table-responsive mt-4 table-wrapper-scroll-y tableFixHead">
      <table class="table table-bordered table-rounded text-center">
        <thead class="table-primary">
          <tr>
            <th>#</th>
            <th>Employee Id</th>
            <th>Name</th>
            <th>Basic Pay</th>
            <th>Per Day Salary</th>
            <th>Working Days</th>
            <th>Leave Days</th>
            <th>Other Allowance</th>
            <th>Deduction</th>
            <th>Bonus</th>
            <th>Net Pay</th>
            <th>Remarks</th>
            <th>HR Approval</th>
          </tr>
        </thead>
        <tbody *ngIf="payrollDetails.length > 0; else noDataFound">
          <tr *ngFor="let employee of payrollDetails; let i = index" [class.table-secondary]="employee.isUpdated">
            <td>{{i+1}}</td>
            <td>{{employee?.employeeCode}}</td>
            <td>{{employee?.employeeDetails?.employeeName}}</td>
            <td><input class="form-control text-center" [value]="employee?.basicPay | currency : 'INR' : ''" readonly>
            </td>
            <td><input class="form-control text-center" [value]="employee?.payPerDay | currency : 'INR' : ''" readonly>
            </td>
            <td><input class="form-control text-center" [value]="employee?.daysWorked" readonly></td>
            <td><input class="form-control text-center" [value]="employee?.totalLeaves" readonly></td>
            <td><input class="form-control text-center" [(ngModel)]="employee.otherAllowance"
                (input)="calculateNetPay(employee)" [disabled]="employee.isUpdated"></td>
            <td><input class="form-control text-center" [(ngModel)]="employee.deductionAmount"
                (input)="calculateNetPay(employee)" [disabled]="employee.isUpdated"></td>
            <td><input class="form-control text-center" [(ngModel)]="employee.bonusAmount"
                (input)="calculateNetPay(employee)" readonly [disabled]="employee.isUpdated"></td>
            <td><input class="form-control text-center" [value]="employee.netPay | currency : 'INR' : ''" readonly></td>
            <td><textarea [(ngModel)]="employee.remarks" [disabled]="employee.isUpdated"></textarea></td>
            <td><button type="button" class="btn btn-primary" (click)="Update(i)" [disabled]="employee.isUpdated">Accept</button></td>
          </tr>
        </tbody>
        <ng-template #noDataFound>
          <tr>
            <td colspan="13">Data Not Found</td>
          </tr>
        </ng-template>
      </table>
    </div>
</section>
